import React from 'react';

import { useTranslation } from 'react-i18next';

import { resourceShape } from 'components/helpers/serialisableResources';
import { personDisplayName } from 'components/helpers/users';

export default function PersonnelSidePanelLineManagerTab({ lineManager }) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <div className='tw-border-grey-100 tw-px-5 tw-py-6'>
      {lineManager ?
        <p>{personDisplayName({ attributes: lineManager.attributes })}</p>
      : <div className='tw-text-grey-400'>{i18nTShared('notSet')}</div>}
    </div>
  );
}

PersonnelSidePanelLineManagerTab.propTypes = {
  lineManager: resourceShape('lineManager'),
};
